import axios from "../utils/axios-interceptor";

export const getSecurityValidatorApi = async(payload) => {
  try {
    const res = await axios.post("/scan-repo/", payload);
    const data = await res.data
    return data
  } catch (error) {
    throw new Error(error.message)
  }
}